import {ZITI_DATA_SERVICE, ZitiDataService, ExtensionService, GrowlerService} from "ziti-console-lib";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  Inject,
} from '@angular/core';
import {isEmpty, cloneDeep, unset} from 'lodash';
import _ from 'lodash';
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {Location} from "@angular/common";
import { ScimIntegration, IntegrationAuthRequest, IntegrationAuthResponse } from '@netfoundry-ui/shared/model';
import { ApiService, LoggerService } from "@netfoundry-ui/shared/services";
import { ScimIntegrationService } from '@netfoundry-ui/shared/apiv2';

import { Subscription, Subject } from "rxjs";
import { GrowlerData } from "@netfoundry-ui/shared/growler";

@Component({
    selector: 'lib-scim-integration-form',
    templateUrl: './scim-integration-form.component.html',
    styleUrls: ['./scim-integration-form.component.scss'],
    standalone: false
})
export class ScimIntegrationFormComponent implements OnInit, OnChanges {
  @Input() isModal = false;
  @Input() formData: any = {};
  close: EventEmitter<any> = new EventEmitter<any>();

  isEditing = false;

  formView = 'simple';

  errMap:  any = {};

  saveSubject = new Subject<boolean>;
  mappingConfigUpdateSubject = new Subject<boolean>;

  moreActions: any[] = [];
  protected isLoading = false;
  initData: any = {};
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  _dataChange = false;
  public errors: any = {};
  basePath = '';
  previousRoute;
  protected usePreviousLocation = true;
  subscription: Subscription = new Subscription();
  @Input() entityId: string;
  baseHref: any;
  formInit = false;
  integrationUrl: string;
  currentNetwork: any;
  
  processing = false;
  generatingToken = false;

  hasExistingToken = false;

  constructor(
      private apiService: ApiService,
      private logger: LoggerService,
      public svc: ScimIntegrationService,
      private growlerService: GrowlerService,
      @Inject(ZITI_DATA_SERVICE) protected zitiService: ZitiDataService,
      private location: Location,
      protected router?: Router,
      protected route?: ActivatedRoute,
  ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (!isEmpty(id)) {
                    this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
              
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();
  }

  ngOnInit(): void {

    this.apiService.currentNetwork.pipe().subscribe((network) => {
      this.currentNetwork = network;
    });
    
    if (this.entityId) {
        if (this.entityId === 'create') {
            this.formData = new ScimIntegration();
            this.initData = cloneDeep(this.formData);
            this.entityUpdated();
            return;
        }
        this.isEditing = true;
        this.isLoading = true;
        this.getIntegration().then((results) =>{ 
          
        }).finally(() => {
          this.isLoading = false;
        });
    }
    this.formInit = true;
  }

  
  getIntegration() {
    return this.svc.getIntegration(this.entityId).then((entity: ScimIntegration) => {
      this.formData = entity
      this.setIntegrationUrl();
      this.initData = cloneDeep(this.formData);
      this.entityUpdated();
      this.hasExistingToken = this.formData.serviceIdentityId && this.formData.jwtConnectionId;
      return entity; 
    });
  }

  setIntegrationUrl() {
    this.integrationUrl = `${this.svc.integrationClientUrl}${this.formData.integrationKey}/scim/v2/`;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isEditing = !isEmpty(this.formData.id);
  }

  initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

  entityUpdated() {
    if (this.formData.id) {
    }
    
    unset(this.formData, '_links');
    this.initData = cloneDeep(this.formData);
  }


  

  headerActionRequested(action: any) {
    switch(action.name) {
      case 'save':
        this.save();
        break;
      case 'close':
        this.closeForm();
        break;
      case 'toggle-view':
        this.formView = action.data;
        break;
    }
  }


  save(event?: any) {
    if(!isEmpty(this.formData.name)) {
      this.formData.name = this.formData.name.trim();
    }

    if(isEmpty(this.formData.id)) {
      this.formData.networkId = this.currentNetwork.id;
      this.formData.networkGroupId = this.currentNetwork.networkGroupId;
    }
    
    if(!this.validate()) {
      return;
    }

    this.processing = true;
    this.isLoading = true;
    const proms = [];
    if(this.isEditing) {
      this.saveSubject.next(true);
      const updateSubjectPromise = new Promise<boolean>((resolve) => {
        this.mappingConfigUpdateSubject.subscribe((wasUpdated: boolean) =>{
          resolve(wasUpdated);
        });
      })
      proms.push(updateSubjectPromise);
    }

    

    const scimUpdatePromise = this.svc.save(this.formData).then((result) => {

      if(result.length > 0) {
        this.errMap = this.processErrors(result);
        return false;
      }


      if (this.isModal) {
        this.closeModal(true, true);
        return;
      }
      this.initData = this.formData;

      this.formData = result;

      this._dataChange = false;
      return true;
    });

    proms.push(scimUpdatePromise);

    Promise.all(proms).then((results) => {
      if(results[0] === true && results[1] === true) {
        this.returnToListPage();

        // TODO success message;
      }
    }).finally(() => {
      this.processing = false;
      this.isLoading = false;
    });
  }

  validate() {
    this.errMap = {};
    if (isEmpty(this.formData.name)) {
      this.errMap['nameRequired'] = true;
    }
    
    return isEmpty(this.errMap);
  }

  
  clear(): void {
  }

  closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
    this.close.emit({refresh: refresh});
    if (event) {
        event.stopPropagation();
    }
  }

  closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
  }

  returnToListPage() {
    if (this.location && this.previousRoute && this.usePreviousLocation) {
      this.location.back();
    } else {
      this.router?.navigateByUrl(`${this.basePath}/scim`);
    }
  }

  copyIntegrationUrl() {
    navigator.clipboard.writeText(this.integrationUrl);
    this.growlerService.show(
        new GrowlerData(
            'success',
            'Success',
            'Integration URL Copied',
            'The URL has been copied to your clipboard'
        )
    );
  }

  private processErrors(errors: any) {

    // handle system error
    if(errors[0] ['http'] || errors[0] ['invalid']) {
      this.logger.error('Error from scim-integrations',errors[0]['http']?.message ?? errors[0] ['invalid']);
      this.growlerService.show(
          new GrowlerData(
          'error',
          'SCIM Integration update request failed. ',
          errors[0] ['http']?.message ?? errors[0] ['invalid']
          )
      );
      return {};
    } else {
      const errorMap: any = {};
      errors.forEach((err: any) => {
          errorMap[err.label] = err.message;
      })

      return errorMap;

    }
  }

  mappingConfigUpdateHandler(wasUpdated: boolean) {
    this.mappingConfigUpdateSubject.next(wasUpdated);
  }

  

}